import i18next from "i18next";

export enum EventFormula {
  FIFO = "FIFO",
  DRAW = "DRAW",
}

export const EventApplyTypeToString = (formula: EventFormula) => {
  if (formula === EventFormula.FIFO) {
    return i18next.t("eventdetail_formula_fcfs");
  } else if (formula === EventFormula.DRAW) {
    return i18next.t("eventdetail_formula_lottery");
  } else {
    return "";
  }
};
